import { ArchivedOrganizerJsonResponse, DeliveredOrganizerJsonResponse, InProcessOrganizersJsonResponse, OrganizerStatusJsonResponse, RecycleBinOrganizerJsonResponse, SignerDetailsJsonResponse } from "../../common/model/sso/jsonResponse";
import { createCommonJsonResponse } from "../objectTypeConstants";

export const archivedOrganizerJsonResponse: ArchivedOrganizerJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        organizerId: "string",
        clientName: "string",
        clientID: "string",
        taxpayerEmail: "string",
        spouseEmail: "string",
        taxYear: 0,
        ero: 0,
        deliveredDate: "YYYY-MM-DDTHH:MM.SSSZ",
        sentBy: "string",
        batchName: "string",
        organizerReminder: "string",
        signingReminder: "string",
        signatureStatus: 0,
        organizerStatus: 0,
        sourceDocumentStatus: 0,
        locationId: 0
    }],
}

export const signerDetailsJsonResponse: SignerDetailsJsonResponse = {
    ...createCommonJsonResponse(200),
    data: {
        name: "string",
        emailAddress: "string",
        signerGuid: "string",
        signerType: 0,
        signingOrder: 1,
        signedOn: "YYYY-MM-DDTHH:MM.SSSZ",
        isDeceased: false,
        signatureStatus: 1
    },
}

export const deliveredOrganizerJsonResponse: DeliveredOrganizerJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        organizerId: "string",
        clientName: "string",
        clientID: "string",
        taxpayerEmail: "string",
        spouseEmail: "string",
        taxYear: 0,
        ero: 0,
        deliveredDate: "YYYY-MM-DDTHH:MM.SSSZ",
        sentBy: "string",
        batchName: "string",
        organizerReminder: "string",
        signingReminder: "string",
        signatureStatus: 0,
        organizerStatus: 0,
        sourceDocumentStatus: 0,
        locationId: 0
    }],
}

export const inProcessOrganizersJsonResponse: InProcessOrganizersJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        organizerId: "string",
        organizerName: "string",
        clientId: "string",
        eroSigner: "string",
        assignedTo: "string",
        status: "0",
        uploadedDate: "string",
        taxReturnType: "0",
        taxYear: 0,
        locationId: 0
    }],
}

export const recycleBinOrganizerJsonResponse: RecycleBinOrganizerJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        batchName: "string",
        clientID: "string",
        clientName: "string",
        deliveredDate: "string",
        ero: "string",
        organizerId: "string",
        organizerStatus: 0,
        sentBy: "string",
        signatureStatus: 0,
        sourceDocumentStatus: 0,
        taxYear: 0,
        deletedBy: "string",
        deletedDate: "string",
        locationId: 0
    }],
}

export const organizerStatusJsonResponse: OrganizerStatusJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        organizerId: "string",
        clientID: "string",
        organizerStatus: 0,
        lastOrganizerReminder: "string",
        signatureStatus: 0,
        lastSignatureReminder: "string",
        sourceDocumentStatus: 0,
        isArchived: false
    }],
}